import { Button as ReactstrapButton } from "reactstrap";


const Button = ({color,onClick,className,children}: any) =>{
    return(
        <ReactstrapButton color={color} onClick={onClick} className={className}>
            {children}
        </ReactstrapButton>
    )
}
export default Button;
